import React from "react";


export const ChevronLeftIcon = (props) => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="20"
        fill="none"
        viewBox="0 0 12 20"
      >
        <path
          fill="#43454C"
          d="M10 20L0 10 10 0l1.775 1.775L3.55 10l8.225 8.225L10 20z"
        ></path>
      </svg>
    )
}

export const ChevronRighttIcon = (props) => {

    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="20"
        fill="none"
        viewBox="0 0 12 20"
      >
        <path
          fill="#43454C"
          d="M2 0l10 10L2 20 .225 18.225 8.45 10 .225 1.775 2 0z"
        ></path>
      </svg>
    )
}